<template lang="pug">
    d2-container( )
        el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="75px" label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='标题' )
                    el-input.inputWidth(v-model='dataForm.title' clearable)
              el-col(:md='6' :sm="12")
                el-form-item(label='资讯类型')
                    el-select.inputWidth(v-model='dataForm.type',placeholder='请选择',clearable)
                        el-option(label='培训',value="1")
                        el-option(label='竞赛',value="2")
                        el-option(label='活动',value="3")
                        //- el-option(label='专栏',value="4")
                        el-option(label='图片直播',value="4")
              //- el-col(:md='6' :sm="12")
              //-   el-form-item(label='主办方' )
              //-       el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" clearable)
              //-           el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
              el-col(:md='6' :sm="12")
                el-form-item(label="发布时间")
                    el-date-picker( style='width:210px;'  v-model='dataForm.publishTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        el-row()
          el-col(:md='6' :sm="12")
            el-form-item(label='状态' )
                el-select.inputWidth(v-model='dataForm.status',placeholder='请选择',clearable)
                    el-option(label='新建',value="1")
                    el-option(label='已发布',value="2")
          el-col(:md='6' :sm="12")
            el-form-item(label='置顶' )
                el-select.inputWidth(v-model='dataForm.isTop',placeholder='请选择',clearable)
                    el-option(label='已置顶',value="1")
                    el-option(label='未置顶',value="2")
        el-row(style="padding-bottom:15px;" :span="24")
          el-col(:span="23")
            el-button(@click='addOrUpdateHandle()',type='primary' v-if="isAuth('pb:news:add')") 新建
            el-button(@click='publish()',type='primary' :disabled='dataListSelections.length <= 0' v-if="isAuth('pb:news:publish')" ) 发布
            el-button(@click='cancelPublish()',type='primary' :disabled='dataListSelections.length <= 0' v-if="isAuth('pb:news:cancelPublish')" ) 撤回
            el-button(@click='toTop()',type='primary' :disabled='dataListSelections.length <= 0' v-if="isAuth('pb:news:toTop')" ) 置顶
            el-button(@click='cancelTop()',type='primary' :disabled='dataListSelections.length <= 0' v-if="isAuth('pb:news:cancelTop')" ) 取消置顶
            el-button(@click='deleteitem(dataListSelections)',type='danger' :disabled='dataListSelections.length <= 0' v-if="isAuth('pb:news:del')" ) 删除
          el-col(:md='1' :sm="12" style='float:right;')
                  el-button(@click='getDataList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" id="out-table" style="width: 100%" , @selection-change='selectionChangeHandle' v-loading='dataListLoading' border)
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='title',header-align='center',align='center',label='标题')
            el-table-column(prop='type',header-align='center',align='center',label='资讯类型')
              template(slot-scope='scope')
                  font(v-if='scope.row.type === 1') 培训
                  font(v-if='scope.row.type === 2') 竞赛
                  font(v-if='scope.row.type === 3') 活动
                  //- font(v-if='scope.row.type === 4') 专栏
                  font(v-if='scope.row.type === 4') 图片直播
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='publishTime',header-align='center',align='center',label='发布日期' sortable)
              template(slot-scope='scope')
                  font {{scope.row.publishTime?scope.row.publishTime.split(' ')[0]:''}}
            el-table-column(prop='summary',header-align='center',align='center',label='摘要' )
              template(slot-scope='scope')
                  span(:title="scope.row.summary") {{scope.row.summary | ellipsis}}
            el-table-column(prop='status',header-align='center',align='center',label='状态')
              template(slot-scope='scope')
                  font(v-if='scope.row.status === 1') 新建
                  font(v-if='scope.row.status === 2') 已发布
                  font(v-if='scope.row.status === 3') 已撤回
            el-table-column(prop='isTop',header-align='center',align='center',label='置顶')
              template(slot-scope='scope')
                  font(v-if='scope.row.isTop === 1') 是
                  font(v-if='scope.row.isTop === 2') 否
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1"   @click="viewHandle(scope.row)" v-if="isAuth('pb:news:detail')" ) 查看基本信息
                                el-menu-item(index="1-2"  @click="addOrUpdateHandle(scope.row.id)" v-if="isAuth('pb:news:update')"  ) 修改
                                el-menu-item(index="1-3"  @click='deleteitem(scope.row.id)' v-if="isAuth('pb:news:del')" ) 删除
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- 新增-修改
        add-or-update(v-if='addOrUpdateVisible',ref='addOrUpdate',@refreshDataList='getDataList')
        view-info(v-if='viewVisible', ref='viewInfo')
</template>

<script>
import '../../../util/jquery-3.3.1.min'
import AddOrUpdate from './add-or-update'
import ViewInfo from './view-info'
export default {
  name: 'mb-member',
  data () {
    return {
      isCollapse: true,
      dataForm: {
        orgId: '',
        type: '',
        publishTime: '',
        startScore: '',
        endScore: ''
      },
      orgName: '',
      ids: new Array(),
      tableData: [],
      rightData: [],
      leftData: [],
      argueData: [],
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      dataListSelections: [],
      sysOrgList: [],
      pageIndex: 1,
      pageIndex1: 1,
      pageSize: 10,
      pageSize1: 10,
      totalPage: 0,
      totalPage1: 0,
      dataListLoading: false,
      memberOrgListLoading: false,
      startScoreMin: '',
      StartScoreMax: Infinity,
      endScoreMin: '',
      addOrUpdateVisible: false,
      viewVisible: false,
      dialogFormVisible: false,
      gameVisible: false,
      argueVisible: false,
      senseVisible: false,
      mbBelongList: [],
      orgIdList: []
    }
  },
  components: {
    AddOrUpdate,
    ViewInfo
  },
   filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 7) {
        return value.slice(0, 7) + '...'
      }
      return value
    }
  },
  created () {
    this.getDataList()
    this.changeOrg()
  },
  methods: {
    handleOpen () {},
    handleClose () {},
    //新增按钮事件
    addOrUpdateHandle (row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row)
        // this.$refs.addOrUpdate.init(520);
      })
    },
    //查看详情
    viewHandle (row) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(row)
      })
    },
    // 删除
    deleteitem (id) {
        console.log(id, 999)
        if (typeof (id) !== 'string') {
          if (id.length == 0) return this.$message.error('未勾选任何项目！')
          let ids = []
          id.forEach(e => {
            ids.push(e.id)
          })
          id = ids.join()
        }
        this.$confirm('此操作将永久删除该资讯, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbNews/delete/${id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success('删除成功!')
              this.getDataList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    selectable (row, index) {
      if (row.name == '国奥利贤') {
        return false
      } else {
        return true
      }
    },
    getDataList1 () {
      this.memberOrgListLoading = true
      console.log(this.rightData)
      this.rightData.forEach(data => {
        this.orgIdList.push(data.id)
      })
      this.$http({
        url: this.$http.adornUrl('/sysOrg/orgList'),
        method: 'get',
        params: this.$http.adornParams({
          page: this.pageIndex1,
          limit: this.pageSize1,
          name: this.orgName,
          orgIdList: JSON.stringify(this.orgIdList)
        })
      }).then(data => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.totalPage1 = data.page.total
        } else {
          this.leftData = []
          this.totalPage1 = 0
        }
        this.memberOrgListLoading = false
      })
    },
    checkAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    // 选中
    handelSelect () {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftData)
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      )
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
      this.nowSelectRightData = []
    },
    handleConcatArr (rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    //发布事件
    publish () {
      this.dofabu(1, 2, null, '确定发布？')
    },
    //取消发布
    cancelPublish () {
      this.dofabu(1, 3, null, '确定撤回？')
    },
    // 顶置
    toTop () {
      this.dofabu(2, null, 1, '确定顶置？')
    },
    // 取消顶置
    cancelTop () {
      this.dofabu(2, null, 2, '确定取消顶置？')
    },
    // ids，type（1为发布、撤回；2为置顶、取消置顶）
    // status 状态1.新建2.已发布3.已撤回，
    // isTop 是否置顶 1.是2否
    dofabu (type, status, isTop, tip) {
      if (this.dataListSelections.length < 1) return this.$message.error('未勾选任何项目！')
      let ids = []
      let fb = 1 //2.已发布3.已撤回，
      this.dataListSelections.forEach(e => {
        if (status == 2 && e.status == 2) { fb = 2 }
        if (status == 3 && e.status == 3) { fb = 3 }
        ids.push(e.id)
      })
      if (fb == 2) return this.$message.error('所选包含已发布资讯，请勿重复发布！')
      if (fb == 3) return this.$message.error('所选包含已撤回资讯，请勿重复撤回！')

      ids = ids.join()
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/pbNews/updateStatus`),
          method: 'post',
          params: {
            ids: ids,
            type: type,
            status: status,
            isTop: isTop
          }
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message.success('操作成功!')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/pbNews/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
          title: this.dataForm.title,
          type: this.dataForm.type,
          strDate: this.dataForm.publishTime[0] || '',
          endDate: this.dataForm.publishTime[1] || ''
        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    sizeChangeHandle1 (val) {
      this.pageSize1 = val
      this.pageIndex1 = 1
      this.getDataList1()
    },
    changeOrg () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams({
          cityId: '',
          proviceId: ''
        })
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    currentChangeHandle1 (val) {
      this.pageIndex1 = val
      this.getDataList1()
    }
  }
}
</script>
<style>
  /* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}

.el-input-number--mini .el-input__inner {
    padding-left: 25px;
    padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease, .el-input-number--mini .el-input-number__increase {
    width: 24px;
    font-size: 12px;
}
.el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 0px;
    vertical-align: top;
}

</style>
